import { useState } from 'react'
import InlineAlert from '../BaseComponents/Alert/InlineAlert'
import { FOCUS_VISIBLE_RING } from '../../lib/a11yFocus'

export const SMALL_SCREEN_NOTICE_STORAGE_KEY = 'smallScreenNoticeDismissed'

// Shown below the lg breakpoint on pages that are not yet designed for small screens; dismissal lasts for the browser session.
function SmallScreenNotice() {
	const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(SMALL_SCREEN_NOTICE_STORAGE_KEY) === 'true')

	if (dismissed) {
		return null
	}

	const dismiss = () => {
		sessionStorage.setItem(SMALL_SCREEN_NOTICE_STORAGE_KEY, 'true')
		setDismissed(true)
	}

	return (
		<InlineAlert type='info' className='lg:hidden mx-lg mt-4' data-testid='small-screen-notice'>
			<div className='flex items-start justify-between gap-4'>
				<span>This page has not yet been optimised for smaller screens. For the best experience, use a larger screen.</span>
				<button
					type='button'
					onClick={dismiss}
					aria-label='Dismiss notice'
					className={`shrink-0 rounded px-1 ${FOCUS_VISIBLE_RING}`}
				>
					<span className='fa-solid fa-xmark' aria-hidden='true' />
				</button>
			</div>
		</InlineAlert>
	)
}

export default SmallScreenNotice
